import StoreLocatorPageCustomData from "../pages/StoreLocatorPageCustomData";

const StoreLocatorSauceFinder = (props) => {
  return <StoreLocatorPageCustomData />;
};

export default StoreLocatorSauceFinder;
